function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombiBoxX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2857",
    d: "M24 12A12 12 0 1 1 12 0a12 12 0 0 1 12 12",
    style: {
      fill: "#ff00b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vereinigungsmenge 38",
    d: "M2977.273 9804.869a1.5 1.5 0 1 1 1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-.33-8.27-5.306-5.271V9789h14.242v2.316l-5.318 5.229v3.448l-3.613 2.33zm.679 4.489 2.254-1.454v-2.806h-2.254zm-.229-4.993h2.66l4.861-4.779h-12.334zm-5.1-5.446h12.907v-.979h-12.9zm12.933 11.141v-3.97h2.018v3.97zm-3.276 0v-3.97h2.018v3.97zm-8.422 0v-3.97h2.021v3.97zm-3.531 0v-3.97h2.018v3.97z",
    transform: "translate(-2966.624 -9785.23)",
    style: {
      fill: "#fff",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombiBoxX24);
export default __webpack_public_path__ + "static/media/combi-box-x24.7d66b1372f30f172156761c0eb29208b.svg";
export { ForwardRef as ReactComponent };